<template>
  <v-card class="elevation-0">
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Notification</h4></v-toolbar-title>
      <span v-if="GetCount > 0" style="position: absolute;right: 20px;font-size: 12px;cursor: pointer;" @click="ReadAll">Read All</span>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list two-line class="pa-0" v-if="Items.length > 0">
        <template v-for="(item, index) in Items">
          <v-divider v-if="item.divider" :key="index"></v-divider>
          <v-list-tile @click="OpenItem(item)" avatar v-else :key="item.title" :class="[item.Unread ? 'activeClass' : '']">
            <v-list-tile-avatar color="light-green">
              <v-icon dark>people</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title>{{ item.Notification_Message }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="caption" style="position: absolute;bottom: -21px;right: 10px;">
              {{ ConvertTime(item.Created_On) }}
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <v-flex v-else>
          <div style="text-align: center;color: #8080805e;font-size: 18px;height: 150px;padding: 12%; width: 350px;">
          <div>Its empty in here</div>
          <div>Oops! Seems like there's nothing</div>
      </div>
      </v-flex>
      <v-divider></v-divider>
      <v-btn block flat class="ma-0" @click="OpenActivities">All</v-btn>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
export default {
  data(){
      return  {

          Items        : [],
          Unread_Count : 0
      }
  },
  computed:{
      GetCount(){
        return this.Unread_Count
      }
  },
  methods:{
      ConvertTime(Time){
          return moment(Time).fromNow()
      },
      ReadAll(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/notification/readnotification`,{ limit:5, page : this.pages })
                    .then(response =>{
                        
                        this.Items = []
                        response["data"]['response'].forEach(element => {
                                this.Items.push(element)
                                this.Items.push({ divider: true, inset: true })
                        });
                        this.Unread_Count = response["data"]['Unread']
                        this.$emit('SetCount',response["data"]['Unread'])
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
      },
      OpenItem(Item){
          
          if(Item['Notification_Type'] == "Trainer_Course"){
              this.$router.push('/trainercourse')
          }else if(Item['Notification_Type'] == 'Trainer_Register'){
              this.$router.push('/trainerlist')
          }
      },
      OpenActivities(){
         this.$router.push('/activities')
      }
  },
  mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/notification/getnotification`,{ limit:5, page : this.pages })
                    .then(response =>{
                        
                        response["data"]['response'].forEach(element => {
                                this.Items.push(element)
                                this.Items.push({ divider: true, inset: true })
                        });
                        this.Unread_Count = response["data"]['Unread']
                        this.$emit('SetCount',response["data"]['Unread'])
                        this.$eventHub.$emit("LOADING",'false')
                    })
                    .catch(err =>{
                        this.$eventHub.$emit("LOADING",'false')
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
  }

};
</script>
<style>
.activeClass{
  background: #d3d3d3a6 !important;
}
</style>